import { tiposContratacao } from '../types'
export const isTipoContrato = (tipoContratacao: string): boolean =>
  tipoContratacao === tiposContratacao[0].value
